import BaseUtil from "../../util/BaseUtil";
import {trainTypeArray} from "./trainViewModel";
import dayjs from "dayjs";
const type = `@@ActionType/UPDATE@${__filename}`;

const ALL_OPTION_VALUE = "ALL";

const initState = {
    groupEnabledFinding: true, // 字段组开启状况
    trainTypeArray: trainTypeArray,
    selectedTrainType: null, // 选中的考核类型
    itemsByCode: null, // 字段
    items: null, // 字段groupBy group
    dicts: null, // 培训内容字典
    initializing: true, // 初始化（字段请求）

    data: null,
    tableLoading: false, // 数据加载
    needRefresh: false, // 需要刷新，详情页关闭时进行判断
    editModalVisible: false,
    toEditData: null, // 代编辑数据
    // pageable: {
    //     limit: 30,
    //     current: 1, // 分页
    // },

    selectedUnitIds: null,
    selectedYear: dayjs(),
    selectedLevelType: null,
    selectedContent: null, // 类别
    selectedForm: null, // 培训形式
    selectedHourType: null, // 学时类型
    selectedCreditType: null, // 学分类型
    keyword: "", // 搜索关键词

    detailModalVisible: false, // 查看明细显隐
    detailRecord: null, // 查看明细点击的record
    detailLoading: false, // 查看明细加载
    detailData: null, // 查看明细数据
    detailFilter: {
        year: dayjs(),
        levelType: null,
        creditType: null,
        hourType: null,
        trainType: null,
    },
    totalCredits: {},
    totalHours: {},

    editOptionModalVisible: false,
    editOptionData: null,
    editOptionModalLoading: false,
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    ALL_OPTION_VALUE,
};
export default viewModel;
